import React, { useState, useEffect } from 'react';
import { debounce } from 'lodash';
import { VerticalAlignTopOutlined } from '@ant-design/icons';
import { Avatar } from 'antd';

import s from './styles.module.scss';
import BaseIconButton from '../base-icon-button';

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const toggleVisibility = debounce(() => {
    if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, 50);

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, [toggleVisibility]);

  return (
    <>
      {isVisible && (
        <BaseIconButton
          onClick={scrollToTop}
          className={s.scroll}
          icon={
            <Avatar
              shape="circle"
              size={48}
              style={{ backgroundColor: 'var(--color-primary)', color: '#fff' }}
              icon={<VerticalAlignTopOutlined />}
            />
          }
        />
      )}
    </>
  );
};

export default ScrollToTopButton;
